<h1 mat-dialog-title style="text-align: center;"><b>Confirmation</b></h1>
<div mat-dialog-content style="width:400px;">
  <ng-container *ngIf="displayDefaultTemplate && !displayCustomText">
    <p style="text-align:center;">Are you sure you want to {{ data.message }}</p>
  </ng-container>
  <ng-container *ngIf="!displayDefaultTemplate && !displayCustomText">
    <p style="text-align:center;">{{ data.message }}</p>
  </ng-container>
  <ng-container *ngIf="displayCustomText">
    <p [ngClass]="data?.messageClass"
      style="text-align:center;"
      [innerHTML]="data.message"
      ></p>
      <small [ngClass]="data?.noteClass" style="text-align:center;" [innerHTML]="data.note"></small>
  </ng-container>
</div>
<div mat-dialog-actions align="center">
  <button mat-button class="selectionButton cancelButton" [mat-dialog-close]="false">No</button>
  <button mat-button class="selectionButton saveButton" [mat-dialog-close]="true">Yes</button>
</div>